module.exports = __webpack_public_path__ + "static/media/homepage_product_banner.5c8afbd1.jpg";